import React, { useState } from "react";
import ContactsIcon from "../../assets/icons/contact_edit.svg2";
import InboundNumbersIcon from "../../assets/icons/inbound_numbers.svg2";
import WhiteButton from "../Common/WhiteButton";
import Subheading from "../Common/Subheading";
import { Table } from "react-bootstrap";
import NewFeature from "../Builder/Components/NewFeature";

export default function BillingInboundNumbers() {
  const [inboundNumbers, setInboundNumbers] = useState([
    {
      id: "1",
      number: "1234567",
      status: "N/A",
    },
  ]);
  return (
    <div>
      <NewFeature>
        <div className="d-flex justify-content-between align-items-center">
          <Subheading
            Icon={InboundNumbersIcon}
            heading="Billing Inbound Numbers"
            subheading="Manage inbound numbers used to build Engagements, Inbound Campaigns and Integrations"
          />
          <div className="d-flex flex-wrap gap-2">
            <WhiteButton
              as="RRLink"
              icon={ContactsIcon}
              heading="Boomerang UI Sales"
            />
          </div>
        </div>
        <div className="my-3">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#ID</th>
                <th>Number</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {inboundNumbers.map((i) => (
                <tr>
                  <td>{i.id}</td>
                  <td>{i.number}</td>
                  <td>{i.status}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </NewFeature>
    </div>
  );
}
